<app-frontend-dropdown (click)="onQueryChanged(undefined)"
                       (onSelected)="onChange($event)"
                       (searchChange)="onQueryChanged($event)"
                       [(value)]="value"
                       [autoSelectLatest]="autoSelectLatest"
                       [disabled]="disabled"
                       [displayKey]="displayKey"
                       [fieldName]="fieldName"
                       [isMultiple]="isMultiple"
                       [isSearchable]="isSearchable"
                       [options]="options"
                       [required]="required"
                       [searchOnKey]="searchOnKey"
                       [selectedOptions]="selectedOptions"
                       [title]="title"
                       class="form-field-input"
                       style="z-index: 1052!important;"
></app-frontend-dropdown>
